import React from 'react';

// Single on/off toggle — label + optional description sit to the left,
// matching how every other settings row in the app pairs a label with
// helper text (ConfirmDialog, checkboxes in ExamManagement's modal, etc).
const Switch = ({ checked, onChange, label, description, disabled = false }) => (
  <label className={['flex items-start justify-between gap-4 py-2', disabled ? 'opacity-60' : 'cursor-pointer'].join(' ')}>
    <div className="flex-1 min-w-0">
      {label && <p className="text-sm font-medium text-slate-800">{label}</p>}
      {description && <p className="text-xs text-slate-500 mt-0.5">{description}</p>}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      className={[
        'relative inline-flex flex-shrink-0 h-6 w-11 items-center rounded-full transition-colors duration-200',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-themePrimary/40',
        checked ? 'bg-themePrimary' : 'bg-slate-300',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
      ].join(' ')}
    >
      <span
        className={[
          'inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow transition-transform duration-200',
          checked ? 'translate-x-[22px]' : 'translate-x-[3px]',
        ].join(' ')}
      />
    </button>
  </label>
);

export default Switch;
